import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { DateSelectBase } from '../date-select.base';
import { NgControl } from '@angular/forms';
import { NgbDate, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { DateSelectNoYearFormatter } from '../date-select-no-year-formatter';
import { CustomDateI18n } from '../date-select-custom-date-i18n';


/**
 * Component for selecting a date without the year
 * 
 * @example <fgbcl-date-select-no-year formControlName="anyControlName"></fgbcl-date-select-no-year>
 */
@Component({
  selector: 'fgbcl-date-select-no-year',
  templateUrl: './date-select-no-year.component.html',
  styleUrls: ['./date-select-no-year.component.scss'],
  providers: [
    {
      provide: NgbDatepickerI18n,
      useClass: CustomDateI18n
    },
    {
      provide: NgbDateParserFormatter,
      useExisting: DateSelectNoYearFormatter
    }
  ]
})
export class DateSelectNoYearComponent extends DateSelectBase implements OnInit{
  @Input() label: string;

  constructor(@Optional() @Self() protected ngControl: NgControl) { 
    super(ngControl);
  }

  ngOnInit(): void {
    if( this.innerValue && this.innerValue instanceof NgbDate ){
      // Limit the date range to the current year
      this.minDate = { year: this.innerValue.year, month: 1, day: 1 };
      this.maxDate = { year: this.innerValue.year, month: 12, day: 31 };
    }
    super.ngOnInit();
  }

}
